const CLICK_SYNC_SETTINGS_EXPERIENCE_TYPES = {
  FETCH: '[clickSyncSettingsExperience] fetch',
  SET: '[clickSyncSettingsExperience] set',
  SAVE: '[clickSyncSettingsExperience] save',
  RESET: '[clickSyncSettingsExperience] reset'
}

export default CLICK_SYNC_SETTINGS_EXPERIENCE_TYPES
